"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import { LocationDisplay } from "~/components/ui/location-display-eon";
import { PrintDropdown } from "~/components/ui/print-dropdown-eon";
import ShareDropdown from "~/components/ui/share-dropdown-eon";
import { WatchJobButton } from "~/components/ui/watch-job-button-eon";
import { toSimilarJob } from "~/lib/utils/to-similar-job";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import DetailsBox from "./details-box-eon";
import KununuBox from "./kununu-box-eon";
export default function JobAdTemplate(t0) {
  const $ = _c(71);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job.data.title) {
    t1 = <h2 className="!text-3xl sm:!text-4xl font-bold text-gray-900 tracking-tight" data-source="job">{job.data.title}</h2>;
    $[0] = job.data.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !job.data.locations || job.data.locations.length === 1 ? t.jobad_locationDisplay_single : t.jobad_locationDisplay_multi;
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="font-medium" data-source="lc">{t2}:</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== job) {
    t4 = <LocationDisplay job={job} />;
    $[4] = job;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="text-lg">{t3}{" "}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("grid-cols-2 gap-x-24 text-foreground text-xl md:text-lg lg:grid xl:gap-x-32", "print:break-inside-auto print:text-black", "[&_p+p]:mt-4", "[&_p:not(li>p)]:mb-4 [&_p:not(li>p)]:print:my-0 [&_p:not(li>p)]:print:mb-0 [&_p:not(li>p)]:print:p-0", "[&_h1]:mb-4 [&_h1]:print:my-0 [&_h1]:print:mb-0 [&_h1]:print:p-0", "[&_h2]:mb-4 [&_h2]:print:my-0 [&_h2]:print:mb-0 [&_h2]:print:p-0", "[&_h3]:mb-4 [&_h3]:print:my-0 [&_h3]:print:mb-0 [&_h3]:print:p-0", "[&_li]:mb-1.5", "[&_ul]:mt-4 [&_ul]:mb-8 [&_ul]:ml-6 [&_ul]:list-disc [&_ul]:print:my-0 [&_ul]:print:py-0", "overflow-wrap-break-word");
    t7 = {
      gridTemplateColumns: "minmax(0, 1fr) 400px"
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== job.data.company || $[12] !== job.data.recruiterData?.recruiter_mail || $[13] !== t.apply_email_warning) {
    t8 = job.data.recruiterData?.recruiter_mail !== "justine.valenti@eon.com" && job.data.company !== "Qualitas-AMS GmbH" && <div className="my-6 bg-gray-200 p-4 font-medium text-lg" data-source="lc">{t.apply_email_warning}</div>;
    $[11] = job.data.company;
    $[12] = job.data.recruiterData?.recruiter_mail;
    $[13] = t.apply_email_warning;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t.jobad_description_HL) {
    t9 = <h3 className="sr-only" data-source="lc">{t.jobad_description_HL}</h3>;
    $[15] = t.jobad_description_HL;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== job.content.shortDescription) {
    t10 = job.content.shortDescription && <div className="mt-6"><p dangerouslySetInnerHTML={{
        __html: job.content.shortDescription
      }} data-source="job" /></div>;
    $[17] = job.content.shortDescription;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== job.content.task || $[20] !== job.content.taskHL) {
    t11 = job.content.task && <div className="mt-6">{job.content.taskHL && <h3 className="font-bold" data-source="job">{job.content.taskHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.task
      }} data-source="job" /></div>;
    $[19] = job.content.task;
    $[20] = job.content.taskHL;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== job.content.profile || $[23] !== job.content.profileHL) {
    t12 = job.content.profile && <div className="mt-6">{job.content.profileHL && <h3 className="font-bold" data-source="job">{job.content.profileHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.profile
      }} data-source="job" /></div>;
    $[22] = job.content.profile;
    $[23] = job.content.profileHL;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== job.content.offer || $[26] !== job.content.offerHL) {
    t13 = job.content.offer && <div className="mt-6">{job.content.offerHL && <h3 className="font-bold" data-source="job">{job.content.offerHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.offer
      }} data-source="job" /></div>;
    $[25] = job.content.offer;
    $[26] = job.content.offerHL;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t.jobad_inclusionHL) {
    t14 = <p className="mt-12 font-bold" data-source="lc">{t.jobad_inclusionHL}</p>;
    $[28] = t.jobad_inclusionHL;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const t15 = job.data.language === "CS" ? t.jobad_inclusion_textCZ : t.jobad_inclusion_text;
  let t16;
  if ($[30] !== t15) {
    t16 = <p data-source="lc">{t15}</p>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t.jobad_inclusion_textSub) {
    t17 = <p data-source="lc">{t.jobad_inclusion_textSub}</p>;
    $[32] = t.jobad_inclusion_textSub;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t14 || $[35] !== t16 || $[36] !== t17) {
    t18 = <div>{t14}{t16}{t17}</div>;
    $[34] = t14;
    $[35] = t16;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t13 || $[42] !== t18 || $[43] !== t8 || $[44] !== t9) {
    t19 = <div className="overflow-wrap-break-word">{t8}{t9}{t10}{t11}{t12}{t13}{t18}</div>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t18;
    $[43] = t8;
    $[44] = t9;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== job) {
    t20 = <DetailsBox job={job} />;
    $[46] = job;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== job.data) {
    t21 = toSimilarJob(job.data);
    $[48] = job.data;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t21) {
    t22 = <WatchJobButton jobData={t21} variant="purple" />;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== job) {
    t23 = <ShareDropdown job={job} variant="purple" />;
    $[52] = job;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <PrintDropdown asButton={true} variant="purple" />;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t22 || $[56] !== t23) {
    t25 = <section className="grid h-10 grid-flow-col grid-cols-3 gap-4">{t22}{t23}{t24}</section>;
    $[55] = t22;
    $[56] = t23;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== job) {
    t26 = <KununuBox job={job} />;
    $[58] = job;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t20 || $[61] !== t25 || $[62] !== t26) {
    t27 = <div className="flex flex-col">{t20}{t25}{t26}</div>;
    $[60] = t20;
    $[61] = t25;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t19 || $[65] !== t27) {
    t28 = <div className={t6} style={t7}>{t19}{t27}</div>;
    $[64] = t19;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== t1 || $[68] !== t28 || $[69] !== t5) {
    t29 = <section className="grid w-full justify-center py-10 md:py-20 print:hidden" id="job" tabIndex={-1}><div className="mx-6 max-w-screen-xl md:mx-10">{t1}{t5}{t28}</div></section>;
    $[67] = t1;
    $[68] = t28;
    $[69] = t5;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  return t29;
}